<template>
  <LayoutCheckout v-if="isOrderDataAvailable">
    <template v-if="!isVipStatusState" v-slot:summary-sticky>
      <CheckoutSummaryStickyAccordion
        isShowLabelExpand
        class="dp-block dp-lg-none"
      >
        <template v-slot:title>
          <div class="title-semibold">
            {{ finalPrice | currency2 }}
          </div>
        </template>
        <template v-slot:content>
          <div class="section-summary-sticky-accordion">
            <CheckoutProductItems
              :data="productSummaryItems"
              :branch-type="branchType"
              :cart-delivery="cartDelivery"
            />
            <hr class="divider-gray-83" />

            <!-- Coupon -->
            <template
              v-if="
                isVipApplyCouponAvailable && (isMobile || isTablet)
              "
            >
              <CheckoutApplyCoupon key="summary-sticky" />
              <hr class="divider-gray-83" />
            </template>

            <CheckoutSummary
              :cartSummaryData="cartSummaryData"
              :additionalDiscountLabel="additionalDiscountLabel"
              :isDeposit="isDeposit"
              :isPickupAtStore="!isDelivery"
              :shipDate="shippingDate"
              :branchName="receiveBranchName"
            />
          </div>
        </template>
      </CheckoutSummaryStickyAccordion>
    </template>

    <template v-slot:left-container>
      <OrderDetailSection
        :data="data"
        :finalPrice="finalPrice"
        :isDeposit="isDeposit"
        :isDelivery="isDelivery"
        :depositNumber="depositNumber"
        :receiveBranchName="receiveBranchName"
        :receiveBranchAddress="receiveBranchAddress"
        :fullBillAddress="fullBillAddress"
        :fullTaxAddress="fullTaxAddress"
      >
        <template v-slot:header>
          <OrderDetailHeader
            v-if="isStaffGuaranteePayment"
            :image="require('@/assets/icon/process.svg')"
            :order="data.order"
            title="รอลูกค้าชำระเงินค้ำประกัน"
          />

          <template v-else>
            <OrderDetailHeader
              v-if="data.length === 0 && !isLoading"
              :image="require('@/assets/icon/fail.svg')"
              :order="data.order"
              title="ไม่พบเลขที่ใบจองหรือทำรายการไม่สำเร็จ"
            />

            <template
              v-if="
                data.length !== 0 &&
                  data.status === ORDER_STATUS.COMPLETE
              "
            >
              <OrderDetailHeader
                v-if="data.payment_is_deposit"
                :image="
                  require('@/assets/icon/studio7/icon-check-circle.svg')
                "
                :order="data.order"
                :title="`ขอบคุณ, คุณ ${data.full_name}`"
              />
              <OrderDetailHeader
                v-else
                :image="
                  require('@/assets/icon/studio7/icon-check-circle.svg')
                "
                :order="data.order"
                :title="`ขอบคุณ, คุณ ${data.full_name}`"
              />
            </template>

            <OrderDetailHeader
              v-if="
                data.length !== 0 && data.status === ORDER_STATUS.OK
              "
              :image="
                require('@/assets/icon/studio7/icon-check-circle.svg')
              "
              :order="data.order"
              title="ชำระเงินมัดจำสำเร็จ"
            />

            <OrderDetailHeader
              v-if="
                data.length !== 0 &&
                  data.status === ORDER_STATUS.CREATE
              "
              :image="require('@/assets/icon/icon-pre-complete.svg')"
              :order="data.order"
            >
              <template v-slot:title>
                <template v-if="isPendingPayment">
                  สั่งซื้อล่วงหน้าเริ่มในอีก
                  <span> {{ timer }} วินาที </span>
                </template>
                <template v-else-if="isExpired">
                  หมดเวลาในการชำระเงิน
                </template>
                <template v-else>
                  ดำเนินการชำระเงิน
                  <span :class="{ 'text-red-timer': isTimerUrgent }">
                    ภายใน {{ timer }} วินาที
                  </span>
                </template>
              </template>
            </OrderDetailHeader>

            <template
              v-if="
                data.length !== 0 &&
                  data.status === ORDER_STATUS.PROCESS
              "
            >
              <OrderDetailHeader
                v-if="data.is_pay_at_store"
                :image="require('@/assets/icon/process.svg')"
                :order="data.order"
                title="รอชำระเงิน"
              />
              <OrderDetailHeader
                v-else
                :image="require('@/assets/icon/process.svg')"
                :order="data.order"
                title="กำลังดำเนินการ"
              />

              <FlashMessagePayAtStore
                v-if="data.is_pay_at_store"
                :image="require('@/assets/icon/alarm.svg')"
                :refId="data.ref_id || data.order"
                :showRefId="true"
              />
            </template>

            <template v-if="isPreComplete">
              <template v-if="isProcessPayment">
                <OrderDetailHeader
                  :image="require('@/assets/icon/process.svg')"
                  :order="data.order"
                  title="กำลังตรวจสอบการชำระเงินค้ำประกัน"
                />
                <div class="body-s">
                  หากชำระเงินแล้ว กรุณารอสักครู่ หรือกด "ตรวจสอบสถานะ"
                  อีกครั้ง
                </div>
              </template>

              <template v-else>
                <OrderDetailHeader
                  :image="
                    require('@/assets/icon/icon-pre-complete.svg')
                  "
                  :order="data.order"
                  title="รอชำระเงินค้ำประกัน"
                />
              </template>
            </template>

            <template
              v-if="
                data.length !== 0 &&
                  data.status === ORDER_STATUS.SUCCESS
              "
            >
              <OrderDetailHeader
                v-if="
                  data.itec_sale_order_status === ORDER_STATUS.OK &&
                    data.payment_is_deposit
                "
                :image="require('@/assets/icon/process.svg')"
                :order="data.order"
                title="กำลังดำเนินการ"
              />
              <OrderDetailHeader
                v-else-if="
                  data.itec_sale_order_status === ORDER_STATUS.OK &&
                    data.status_2nd === ORDER_STATUS.COMPLETE
                "
                :image="
                  require('@/assets/icon/studio7/icon-check-circle.svg')
                "
                :order="data.order"
                :title="`ขอบคุณ, คุณ ${data.full_name}`"
              />
              <OrderDetailHeader
                v-else
                :image="
                  require('@/assets/icon/studio7/icon-check-circle.svg')
                "
                :order="data.order"
                :title="`ขอบคุณ, คุณ ${data.full_name}`"
              />
            </template>

            <OrderDetailHeader
              v-if="
                data.length !== 0 &&
                  data.status === ORDER_STATUS.CANCEL
              "
              :image="require('@/assets/icon/fail.svg')"
              :order="data.order"
              title="ระบบทำการยกเลิกรายการแล้ว"
            />

            <!-- VIP -->
            <OrderDetailHeader
              v-if="
                data.length !== 0 &&
                  (data.status === ORDER_STATUS.VIP_PENDING ||
                    data.status === ORDER_STATUS.VIP_CONVERTED)
              "
              :image="
                require('@/assets/icon/studio7/icon-check-circle.svg')
              "
              orderLabel="รายการ"
              :order="data.order"
              :title="
                `ขอบคุณ, คุณ ${data.full_name} ที่ลงทะเบียนความสนใจ\nรายละเอียดจะถูกส่งไปยังอีเมลของคุณ`
              "
            />
            <OrderDetailHeader
              v-if="
                data.length !== 0 &&
                  data.status === ORDER_STATUS.VIP_EXPIRED
              "
              :image="require('@/assets/icon/fail.svg')"
              :order="data.order"
              orderLabel="รายการ"
              title="รายการหมดอายุ"
            />
          </template>
        </template>

        <template
          v-if="
            data.length !== 0 && data.status === ORDER_STATUS.CREATE
          "
          v-slot:timer
        >
          <div class="headline-m font-bold">
            <template v-if="isPendingPayment">
              สั่งซื้อล่วงหน้าเริ่มในอีก
              <span> {{ timer }} วินาที </span>
            </template>
            <template v-else-if="isExpired">
              หมดเวลาในการชำระเงิน
            </template>
            <template v-else>
              ดำเนินการชำระเงิน
              <span :class="{ 'text-red-timer': isTimerUrgent }">
                ภายใน {{ timer }} วินาที
              </span>
            </template>
          </div>
        </template>

        <template
          v-if="
            data.length !== 0 &&
              data.status === ORDER_STATUS.PROCESS &&
              data.is_pay_at_store
          "
          v-slot:flashMessagePayAtStore
        >
          <FlashMessagePayAtStore
            :image="require('@/assets/icon/alarm.svg')"
            :refId="data.ref_id || data.order"
            :showRefId="true"
          />
        </template>

        <template v-slot:appendOrderDetail>
          <slot name="appendOrderDetail" />
        </template>
      </OrderDetailSection>

      <!-- Payment Guarantee Section -->
      <template v-if="isPreComplete">
        <!-- Add inquiry payment -->
        <template v-if="isProcessPayment">
          <PaymentGuaranteeInquiry />
        </template>

        <PaymentGuaranteeMethods v-else @submit="handleSubmitPayment">
          <template v-slot>
            <div class="section-summary">
              <template v-if="bundles.length == 0">
                <div class="headline-m">
                  รายการสั่งซื้อ
                </div>

                <CheckoutProductItems
                  :data="productSummaryItems"
                  :branch-type="branchType"
                  :cart-delivery="cartDelivery"
                  class="mt-4"
                />
              </template>

              <PDPAccordionItem
                v-if="bundles.length > 1"
                isShowLabelExpand
              >
                <template v-slot:title>
                  <div class="headline-m">
                    คำสั่งซื้อ ({{ bundles.length + 1 }})
                  </div>
                </template>
                <template v-slot:content>
                  <CheckoutProductItems
                    :data="productSummaryItems"
                    :branch-type="branchType"
                    :cart-delivery="cartDelivery"
                    class="mt-4"
                  />
                </template>
              </PDPAccordionItem>

              <CheckoutSummary
                :cartSummaryData="cartSummaryData"
                :additionalDiscountLabel="additionalDiscountLabel"
                :isDeposit="data.is_deposit"
                :branchName="data.receive_branch_name"
                :shipDate="shippingDate"
                :isPickupAtStore="!isDelivery"
                :isShowMarketingBanner="!isPreComplete && !isVip"
                class="mt-4"
              />
            </div>
          </template>
        </PaymentGuaranteeMethods>
      </template>

      <!-- Trade-in Section -->
      <template v-if="data?.is_tradein_completed">
        <OrderDetailTradeIn
          :type="data.tradein_type"
          :discount="data.tradein_discount"
          :vouchers="data.tradein_vouchers"
        />
      </template>

      <template v-if="isTradeIn && !isExpired">
        <template
          v-if="
            !data?.is_tradein_completed &&
              data?.status === ORDER_STATUS.CREATE
          "
        >
          <BaseTradeInSection
            ref="baseTradeInSection"
            :options="data?.tradein?.types"
            @skip="
              $refs.paymentContinueProcess?.handlePaymentContinueProcess()
            "
            @success="handlePaymentContinueProcess"
          />
        </template>

        <BaseBoxSection
          v-if="isAllowChangingPaymentMethod"
          :title="isBnn ? 'เปลี่ยนวิธีชำระเงิน' : ''"
        >
          <PaymentMethods
            id="paymentMethodsId"
            type="trade-in"
            :finalPrice="cartSummaryData?.final_price"
            :isDeposit="data.is_deposit"
          >
            <template v-slot:payment-methods-header>
              <div class="alert-warning">
                <v-icon size="16" color="#ff381d">
                  mdi-alert-circle
                </v-icon>
                <strong>
                  ขออภัย, {{ data.payment_type }}
                  <span v-if="data?.payment_selected?.term">
                    ผ่อนชำระ {{ data.payment_selected.term }} เดือน
                    ดอกเบี้ย
                    {{ data.payment_selected.interest || 0 }}%
                  </span>
                  ไม่สามารถใช้งานได้
                </strong>
                <br />
                {{ techswopValidate?.payment_warning_message }}
              </div>
            </template>
          </PaymentMethods>
        </BaseBoxSection>
      </template>

      <PaymentContinueProcess
        v-if="
          !isVip && !isExpired && data?.status === ORDER_STATUS.CREATE
        "
        ref="paymentContinueProcess"
        :loading="tradeInLoading"
        @submit="handleConfirmTechswop"
      >
        <template v-slot:payment-methods-before-actions>
          <div class="dp-block dp-lg-none">
            <div class="section-summary">
              <template v-if="bundles.length == 0">
                <div class="headline-m">
                  รายการสั่งซื้อ
                </div>

                <CheckoutProductItems
                  :data="productSummaryItems"
                  :branch-type="branchType"
                  :cart-delivery="cartDelivery"
                  class="mt-4"
                />
              </template>

              <PDPAccordionItem
                v-if="bundles.length > 1"
                isShowLabelExpand
              >
                <template v-slot:title>
                  <div class="headline-m">
                    คำสั่งซื้อ ({{ bundles.length + 1 }})
                  </div>
                </template>
                <template v-slot:content>
                  <CheckoutProductItems
                    :data="productSummaryItems"
                    :branch-type="branchType"
                    :cart-delivery="cartDelivery"
                    class="mt-4"
                  />
                </template>
              </PDPAccordionItem>

              <CheckoutSummary
                :cartSummaryData="cartSummaryData"
                :additionalDiscountLabel="additionalDiscountLabel"
                :isDeposit="data.is_deposit"
                :branchName="data.receive_branch_name"
                :shipDate="shippingDate"
                :isPickupAtStore="!isDelivery"
                :isShowMarketingBanner="false"
                class="mt-4"
              />
            </div>
          </div>
        </template>
      </PaymentContinueProcess>
      <!-- [END] Trade-in Section -->

      <!-- VIP -->
      <template v-if="isVip && isPaymentOpen && !isExpired">
        <BaseBoxSection :title="isBnn ? 'การชำระเงิน' : ''">
          <CheckoutVipOrder
            ref="checkoutVipOrder"
            :isVip="isVip"
            :finalPrice="cartSummaryData?.final_price"
            @success="handleConfirmPaymentSuccessfully"
          />
        </BaseBoxSection>

        <PaymentContinueProcess
          ref="paymentContinueProcess"
          @process-complete="
            handlePaymentContinueAfterProcessComplete
          "
          @submit="handleConfirmVipPayment"
        >
          <template v-slot:payment-methods-before-actions>
            <div class="dp-block dp-lg-none">
              <div class="section-summary">
                <template v-if="bundles.length == 0">
                  <div class="headline-m">
                    รายการสั่งซื้อ
                  </div>

                  <CheckoutProductItems
                    :data="productSummaryItems"
                    :branch-type="branchType"
                    :cart-delivery="cartDelivery"
                    class="mt-4"
                  />
                </template>

                <PDPAccordionItem
                  v-if="bundles.length > 1"
                  isShowLabelExpand
                >
                  <template v-slot:title>
                    <div class="headline-m">
                      คำสั่งซื้อ ({{ bundles.length + 1 }})
                    </div>
                  </template>
                  <template v-slot:content>
                    <CheckoutProductItems
                      :data="productSummaryItems"
                      :branch-type="branchType"
                      :cart-delivery="cartDelivery"
                      class="mt-4"
                    />
                  </template>
                </PDPAccordionItem>

                <!-- Coupon -->
                <CheckoutApplyCoupon
                  v-if="
                    isVipApplyCouponAvailable &&
                      (isMobile || isTablet)
                  "
                  key="summary-main"
                />

                <CheckoutSummary
                  :cartSummaryData="cartSummaryData"
                  :additionalDiscountLabel="additionalDiscountLabel"
                  :isDeposit="data.is_deposit"
                  :branchName="data.receive_branch_name"
                  :shipDate="shippingDate"
                  :isPickupAtStore="!isDelivery"
                  :isShowMarketingBanner="false"
                  class="mt-4"
                />
              </div>
            </div>
          </template>
        </PaymentContinueProcess>
      </template>

      <template v-if="data.status === ORDER_STATUS.COMPLETE">
        <div class="order-detail-resent-cta">
          <BaseResendOrderDetails />
        </div>

        <!-- TODO: Display order summary on mobile view -->
        <div class="dp-block dp-lg-none">
          <div class="section-summary">
            <template v-if="bundles.length == 0">
              <div class="headline-m">
                รายการสั่งซื้อ
              </div>

              <CheckoutProductItems
                :data="productSummaryItems"
                :branch-type="branchType"
                :cart-delivery="cartDelivery"
                class="mt-4"
              />
            </template>

            <PDPAccordionItem
              v-if="bundles.length > 1"
              isShowLabelExpand
            >
              <template v-slot:title>
                <div class="headline-m">
                  คำสั่งซื้อ ({{ bundles.length + 1 }})
                </div>
              </template>
              <template v-slot:content>
                <CheckoutProductItems
                  :data="productSummaryItems"
                  :branch-type="branchType"
                  :cart-delivery="cartDelivery"
                  class="mt-4"
                />
              </template>
            </PDPAccordionItem>

            <CheckoutSummary
              :cartSummaryData="cartSummaryData"
              :additionalDiscountLabel="additionalDiscountLabel"
              :isDeposit="data.is_deposit"
              :branchName="data.receive_branch_name"
              :shipDate="shippingDate"
              :isPickupAtStore="!isDelivery"
              :isShowMarketingBanner="!isPreComplete && !isVip"
              class="mt-4"
            />
          </div>
        </div>
      </template>

      <!-- isVipStatusState -->
      <template v-if="isVipStatusState && (isMobile || isTablet)">
        <div class="checkout-summary-container mt-4">
          <div
            class="marketing-banner-html"
            v-html="marketingBannerHtml"
          ></div>
        </div>
      </template>

      <div
        v-if="
          ![ORDER_STATUS.CREATE].includes(data?.status) || isExpired
        "
        :class="[
          'order-detail-action',
          { 'is-pre-complete': isPreComplete },
        ]"
      >
        <template v-if="!isPreComplete && !isStaffGuaranteePayment">
          <div class="body-s order-detail-action-text">
            <template v-if="isPayAtStoreTradeInLater">
              <BaseStaffQrCode />
              <div class="vertical-line" />
            </template>

            <div class="contact-us-action">
              หากพบปัญหา
              <v-btn
                :ripple="false"
                color="primary"
                class="btn-link"
                depressed
                plain
                @click="contactUs"
              >
                ติดต่อเรา
              </v-btn>
            </div>
          </div>

          <v-btn
            v-if="!isVip"
            depressed
            :dark="true"
            color="primary"
            :disabled="disabledButton"
            :loading="loading"
            @click="goBack"
          >
            กลับสู่หน้าหลัก
          </v-btn>
        </template>
      </div>
      <Footer />
    </template>

    <template v-slot:right-container>
      <template v-if="isVipStatusState">
        <div
          class="marketing-banner-html"
          v-html="marketingBannerHtml"
        />
      </template>
      <template v-else>
        <CheckoutProductItems
          :data="productSummaryItems"
          :branch-type="branchType"
          :cart-delivery="cartDelivery"
        />

        <hr class="divider-gray-83" />

        <template
          v-if="
            isVipApplyCouponAvailable && (isDesktop || isDesktopLarge)
          "
        >
          <!-- Coupon -->
          <CheckoutApplyCoupon key="summary-main" />
          <hr class="divider-gray-83" />
        </template>

        <CheckoutSummary
          :cartSummaryData="cartSummaryData"
          :additionalDiscountLabel="additionalDiscountLabel"
          :isDeposit="data.is_deposit"
          :branchName="data.receive_branch_name"
          :shipDate="shippingDate"
          :isPickupAtStore="!isDelivery"
          :isShowMarketingBanner="!isPreComplete && !isVip"
        />
      </template>
    </template>
  </LayoutCheckout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import screenSize from '@/mixins/screenSize'
import {
  ORDER_STATUS,
  CONFIRM_PAYMENT_ORDER_TYPE,
  GUARANTEE_PAYMENT_STATUS,
} from '@/config/order'
import branchTypes from '@/config/branchTypes'
import isBnn from '@/config/isBnn'

export default {
  name: 'OrderDetailStudio7',

  mixins: [screenSize],

  props: {
    isStaffGuaranteePayment: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    LayoutCheckout: () =>
      import('@/components/layout/LayoutCheckout'),
    CheckoutProductItems: () =>
      import('@/components/studio7/CheckoutProductItems'),
    CheckoutSummary: () =>
      import('@/components/studio7/CheckoutSummary'),
    CheckoutVipOrder: () =>
      import('@/components/studio7/CheckoutVipOrder'),
    CheckoutApplyCoupon: () =>
      import('@/components/studio7/CheckoutApplyCoupon'),

    PaymentMethods: () =>
      import('@/components/payments/base/PaymentMethods'),
    PaymentGuaranteeMethods: () =>
      import(
        '@/components/payments/guarantee/PaymentGuaranteeMethods'
      ),
    PaymentGuaranteeInquiry: () =>
      import(
        '@/components/payments/guarantee/PaymentGuaranteeInquiry'
      ),
    PaymentContinueProcess: () =>
      import('@/components/payments/base/PaymentContinueProcess'),

    PDPAccordionItem: () =>
      import('@/components/studio7/PDPAccordionItem'),

    Footer: () => import('@/components/bnn/Footer'),

    OrderDetailHeader: () =>
      import('@/components/studio7/OrderDetailHeader'),

    CheckoutSummaryStickyAccordion: () =>
      import('@/components/studio7/CheckoutSummaryStickyAccordion'),

    FlashMessagePayAtStore: () =>
      import('@/components/bnn/FlashMessagePayAtStore'),

    BaseStaffQrCode: () =>
      import('@/components/base/BaseStaffQrCode'),

    BaseResendOrderDetails: () =>
      import('@/components/base/BaseResendOrderDetails'),

    BaseTradeInSection: () =>
      import('@/components/base/tradeIn/BaseTradeInSection'),

    OrderDetailTradeIn: () =>
      import('@/components/studio7/OrderDetailTradeIn'),

    OrderDetailSection: () =>
      import('@/components/order/OrderDetailSection'),

    BaseBoxSection: () =>
      import('@/components/base/BaseBoxSection.vue'),
  },

  data() {
    return {
      // Import
      ORDER_STATUS,
      isBnn,

      countDown: 0,
      countDownInterval: null,
      countDownKey: null,
    }
  },

  provide() {
    return {
      orderCode: () => this.data?.order || '',
      isVipStatusState: () => this.isVipStatusState ?? false,
    }
  },

  computed: {
    ...mapState({
      campaign: state => state.campaign.current,
      data: state => state.order.data,
      paymentId: state => state.paymentType.paymentId,
      isVipPendingPayment: state =>
        state.order.data.is_vip_pending_payment || false,
      isPaymentOpen: state =>
        state.order.data.is_payment_open || false,
      paymentOpensAtTimestamp: state =>
        state.order.data.payment_opens_at_timestamp || 0,
      paymentOpensAt: state => state.order.data.payment_opens_at || 0,
      expireAtTimestamp: state =>
        state.order.data.expire_at_timestamp || 0,
      isLoading: state => state.order.isLoading,
      techswopValidate: state =>
        state.paymentType.techswop.validate?.data,
      tradeInLoading: state =>
        state.paymentType.techswop.validate.isLoading ||
        state.paymentType.techswop.switchBranch?.isLoading ||
        state.paymentType.techswop.confirm?.isLoading ||
        state.paymentType.techswop.changePaymentType?.isLoading,
      marketingBannerHtml: state =>
        state.staticPage.data?.[0]?.html ?? '',
    }),

    ...mapGetters({
      productPaymentOptions: 'paymentType/getProductPaymentOptions',
      isVipApplyCouponAvailableStore:
        'paymentType/getIsVipApplyCouponEnabled',
    }),

    isOrderDataAvailable() {
      return this.data.length !== 0
    },

    isVip() {
      return (
        (this.$route?.name === 'Checkout' &&
          this.data?.status === ORDER_STATUS.CREATE) ||
        this.data?.status === ORDER_STATUS.VIP_PENDING ||
        this.data?.status === ORDER_STATUS.VIP_CONVERTED ||
        this.data?.status === ORDER_STATUS.VIP_EXPIRED
      )
    },

    isVipStatusState() {
      return (
        this.data?.status === ORDER_STATUS.VIP_PENDING ||
        this.data?.status === ORDER_STATUS.VIP_CONVERTED ||
        this.data?.status === ORDER_STATUS.VIP_EXPIRED
      )
    },

    isVipApplyCouponAvailable() {
      return (
        this.isVip &&
        this.isVipApplyCouponAvailableStore &&
        this.isPaymentOpen &&
        !this.isExpired
      )
    },

    isDelivery() {
      return this.data?.is_delivery
    },

    isDeposit() {
      return this.data?.is_deposit
    },

    // props for <CheckoutProductItems> derived from the order payload
    branchType() {
      return this.data?.is_deposit
        ? branchTypes.BRANCH_TYPE_DEPOSIT
        : branchTypes.BRANCH_TYPE_FULL_PAYMENT
    },

    cartDelivery() {
      return this.data?.is_delivery ? 'delivery' : 'store'
    },

    isPayAtStore() {
      return this.data?.is_pay_at_store
    },

    isPayAtStoreTradeInLater() {
      return (
        this.data?.pay_at_store_detail?.order_type ==
        CONFIRM_PAYMENT_ORDER_TYPE.WITH_TRADEIN_LATER
      )
    },

    isPayAtStorePromotion() {
      return (
        this.data?.pay_at_store_detail?.order_type ==
        CONFIRM_PAYMENT_ORDER_TYPE.WITH_PLAN
      )
    },

    isPreComplete() {
      return (
        this.data.length !== 0 &&
        this.data.status === ORDER_STATUS.PRE_COMPLETE &&
        !this.isStaffGuaranteePayment
      )
    },

    isProcessPayment() {
      return (
        this.data?.guarantee_payment_status ===
        GUARANTEE_PAYMENT_STATUS.PROCESS
      )
    },

    isTradeIn() {
      return this.data?.tradein?.enabled
    },

    finalPrice() {
      return (
        this.data?.pay_at_store_detail?.paid_amount ||
        this.data?.total_price ||
        0
      )
    },

    additionalDiscountLabel() {
      return this.isPayAtStorePromotion
        ? 'ส่วนลดจากโปรโมชั่นเบอร์ทรู'
        : 'ส่วนลดเพิ่มเติม'
    },

    insteadSummary() {
      let instead = {}

      if (this.techswopValidate) {
        instead = {
          final_price:
            this.techswopValidate?.order_summary?.final_price ?? 0,
          tradein_discount:
            this.techswopValidate?.order_summary?.voucher_discount ??
            0,
          remain_amount_original:
            this.techswopValidate?.order_summary?.remaining ?? 0,
        }
      }

      return instead
    },

    isAllowChangingPaymentMethod() {
      return (
        this.techswopValidate?.require_payment_change &&
        this.data?.tradein?.enabled &&
        !this.data?.is_tradein_completed &&
        this.data?.status === ORDER_STATUS.CREATE
      )
    },

    cartSummaryData() {
      if (this.isVip && this.paymentId) {
        return {
          ...this.$store.state.cart.cartSummaryData,
          coupons: [],
        }
      }

      return {
        before_discount: this.data?.before_discount,
        summary_discount: Number(this.data?.discount),
        product_price_deposit_summary: this.data?.deposit,
        remain_amount_original: this.data?.remaining,
        final_price: this.finalPrice,

        // Additional discount
        additional_discount: this.isPayAtStorePromotion
          ? this.data?.pay_at_store_detail
              ?.with_plan_promotion_discount
          : Number(this.data?.pay_at_store_detail?.voucher_amount) ??
            0,

        advance_payment: this.data?.pay_at_store_detail
          ?.with_plan_advance_payment,
        advance_payment_optional: this.data?.pay_at_store_detail
          ?.with_plan_advance_payment_optional,

        guarantee_amount: this.data?.guarantee_amount ?? 0,

        coupons: this.data?.coupons ?? [],
        discount_coupon: this.data?.discount_coupon ?? 0,
        tradein_discount: this.data?.tradein_discount ?? 0,

        ...this.insteadSummary,
      }
    },

    bundles() {
      return (
        this.data?.bundle_products?.filter(
          i => i?.type !== 'delivery',
        ) ?? []
      )
    },

    // main product row + bundles, shared by every <CheckoutProductItems>
    productSummaryItems() {
      return [
        {
          imageUrl: this.data?.product_main?.image_url,
          name: this.data?.product_main?.name,
          price_ship: this.data?.product_main?.price,
          price_store: this.data?.product_main?.price,
          price_deposit: this.data?.product_main?.price,
          final_bundle_price: this.data?.product_main?.price,
        },
        ...this.bundles,
      ]
    },

    receiveBranchName() {
      return this.data?.receive_branch_name ?? ''
    },

    receiveBranchAddress() {
      return this.data?.receive_branch_address
        ? `${this.data?.receive_branch_address?.address} ${this.data?.receive_branch_address?.province} `
        : ''
    },

    shippingDate() {
      return (
        this.productPaymentOptions?.message ||
        this.data?.shipping_date ||
        this.data?.receive_date ||
        'ไม่พบข้อมูล'
      )
    },

    fullAddress() {
      return `เลขที่ ${this.data?.address} แขวง/ตำบล ${this.data?.sub_district} เขต/อำเภอ ${this.data?.district} ${this.data?.province} ${this.data?.postcode}`
    },

    fullTaxAddress() {
      return `เลขที่ ${this.data?.tax_address?.address} แขวง/ตำบล ${this.data?.tax_address?.sub_district} เขต/อำเภอ ${this.data?.tax_address?.district} ${this.data?.tax_address?.province} ${this.data?.tax_address?.postcode}`
    },

    fullBillAddress() {
      return `เลขที่ ${this.data?.bill_address?.address} แขวง/ตำบล ${this.data?.bill_address?.sub_district} เขต/อำเภอ ${this.data?.bill_address?.district} ${this.data?.bill_address?.province} ${this.data?.bill_address?.postcode}`
    },

    depositNumber() {
      return this.data?.deposit_number ?? 'กำลังดำเนินการ'
    },

    decryptedData() {
      return this.$store.getters['user/getData']
    },

    isStartingPayment() {
      return this.data?.status === ORDER_STATUS.CREATE
    },

    isPendingPayment() {
      return (
        this.data?.status === ORDER_STATUS.CREATE &&
        this.countDownKey === 'paymentOpensAtTimestamp'
      )
    },

    isExpired() {
      return this.countDown <= 0
    },

    isTimerUrgent() {
      return !this.isExpired && this.countDown < 300
    },

    timer() {
      return moment.utc(this.countDown * 1000).format('HH : mm : ss')
    },
  },

  watch: {
    async isVipStatusState(newVal, oldVal) {
      // When the order transitions into a VIP pending state, re-fetch the
      // VIP marketing banner static page.
      if (newVal && !oldVal) {
        await this.$store.dispatch(
          'staticPage/getStaticPage',
          'vip-marketing-banner',
        )
      }
    },
  },

  async mounted() {
    this.$nextTick(async () => {
      // If 'isVipPendingPayment' is true and this.$route.name is 'OrderDetail' or 'Thank' and 'payment_type_id' is null redirect to 'Checkout' page
      if (
        this.isVipPendingPayment &&
        (this.$route.name === 'Thank' ||
          this.$route.name === 'OrderDetail') &&
        !this.data?.payment_type_id
      ) {
        this.$router
          .push({
            name: 'Checkout',
            params: {
              orderId:
                this.$route.params?.uid ||
                this.$route.params?.orderId,
            },
          })
          .catch(() => true)
      } else if (
        this.$route.name === 'Thank' &&
        this.data?.status === ORDER_STATUS.CREATE
      ) {
        // If the order is still in the CREATE status, redirect to the OrderDetail page
        this.$router
          .push({
            name: 'OrderDetail',
            params: {
              orderId:
                this.$route.params?.uid ||
                this.$route.params?.orderId,
            },
          })
          .catch(() => true)
      }
      // If paymentOpensAtTimestamp incoming and not started yet, use it for countdown. Otherwise, use expireAtTimestamp.
      if (
        this.paymentOpensAtTimestamp &&
        this.paymentOpensAtTimestamp > moment().unix()
      ) {
        this.countDown = moment
          .unix(this.paymentOpensAtTimestamp)
          .diff(moment(), 'seconds')

        this.countDownTimer('paymentOpensAtTimestamp')
      } else if (
        this.expireAtTimestamp &&
        this.expireAtTimestamp > moment().unix()
      ) {
        this.countDown = moment
          .unix(this.expireAtTimestamp)
          .diff(moment(), 'seconds')

        this.countDownTimer('expireAtTimestamp')
      }

      if (this.isVipStatusState) {
        // Fetch marketing banner
        await this.$store.dispatch(
          'staticPage/getStaticPage',
          'vip-marketing-banner',
        )
      } else {
        await this.$store.dispatch(
          'staticPage/getStaticPage',
          'marketing-banner',
        )
      }
    })

    window.scrollTo({
      top: 0,
    })
  },

  methods: {
    contactUs() {
      // TODO: Redirect to contact page new page
      window.open(
        'https://www.studio7thailand.com/th/pages/contact-us',
        '_blank',
      )
    },

    goBack() {
      let slug =
        this.$route.params?.slug ||
        localStorage.getItem('productLatestVisit')

      this.$router.push({
        name: 'ProductDetail',
        params: {
          slug: slug,
        },
      })
    },

    countDownTimer(key) {
      this.countDownKey = key

      // Clear existing interval if any
      if (this.countDownInterval) {
        clearInterval(this.countDownInterval)
      }

      this.countDownInterval = setInterval(() => {
        // Calculate the difference in seconds between the current time and the target timestamp
        this.countDown = moment
          .unix(this[key])
          .diff(moment(), 'seconds')

        if (this.countDown <= 0) {
          // Stop the interval when countDown reaches 0
          clearInterval(this.countDownInterval)

          // Fetch order data when payment window opens
          this.$emit('fetch')

          if (key === 'expireAtTimestamp') {
            // Dispatch action to check if the pay at store option has expired
            this.$store.dispatch('order/isPayAtStoreExpired')
          }
        }
      }, 1000)
    },

    async handleConfirmTechswop() {
      if (this.isAllowChangingPaymentMethod) {
        // Call the handleChangingPaymentMethod method of the PaymentContinueProcess component
        this.$refs.baseTradeInSection?.handleChangingPaymentMethod()
        return
      }

      if (
        this.data?.tradein?.enabled &&
        !this.data?.is_tradein_completed
      ) {
        this.$refs.baseTradeInSection?.handleConfirmTechswop()
        return
      } else {
        await this.handlePaymentContinueProcess()
        return
      }
    },

    handlePaymentContinueProcess() {
      // Call the handlePaymentContinueProcess method of the PaymentContinueProcess component
      this.$refs.paymentContinueProcess?.handlePaymentContinueProcess()
    },

    handleConfirmVipPayment() {
      this.$refs.checkoutVipOrder?.handleConfirmPayment()
    },

    handleConfirmPaymentSuccessfully() {
      if (
        this.data?.tradein?.enabled &&
        this.data?.status === ORDER_STATUS.CREATE
      ) {
        this.$router.push({
          name: 'OrderDetail',
          params: {
            orderId: this.$route.params?.orderId,
          },
        })
        return
      } else {
        this.$refs.paymentContinueProcess?.handlePaymentContinueProcess()
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.text-red-timer {
    color: $color-bnn-red;
	animation: fade 0.75s infinite alternate;
}

@keyframes fade {
	0% {
		opacity: 0.45;
	}
	100% {
		opacity: 1;
	}
}

.order-detail-action {
    display: flex;
	flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 24px;

	&:empty {
		display: none;
	}

    &.is-pre-complete {
        justify-content: center;
    }

	@media screen and (min-width: 1024px) {
		flex-direction: row;
    	gap: 16px;
	}


	.order-detail-action-text {
		display: flex;
		align-items: center;
		gap: 8px;
		order: 1;

		@media screen and (min-width: 1024px) {
			order: 0;
		}
	}
}

.section-summary-sticky {
    background-color: $color-grey-light-80;

    grid-column: span 2;
}

.section-summary-sticky-accordion {
    width 100%
    max-width: 100dvw
    padding: 21px 21px 0;

    display flex;
    flex-direction: column;
    gap: 21px;
}

.full-page
 overflow: visible !important

.order-detail-resent-cta
    background-color: #fff
    border: 1px solid $color-gray85
    border-radius: 8px
    padding-inline: 16px

.-is-bnn
	.order-detail-resent-cta
		border: none


.alert-warning
	font-size: 14px
	background-color: rgba($color-bnn-red, 0.15)
	color: $color-bnn-red
	padding: 8px 16px
	border-radius: 8px

.marketing-banner-html
    max-width: 100%
    overflow: hidden
</style>
